/*eslint-disable*/
import {
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import React from "react";
import { Field } from "redux-form";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const GroupBenefits = props => (
  <Table className="customTable1">
    <TableHead>
      <TableRow>
        <TableCell className="cellPaddingSmall" style={colwidth("11em")}>
          {"Approved Fund Provisions"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("8em")}>
          {"Group Capital"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("8em")}>
          {"Provident Capital"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("8em")}>
          {"Pension Capital"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("8em")}>
          {"Monthly Income"}
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Death</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.death.group_capital`}
              label="Group Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.death.provident_capital`}
              label="Provident Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.death.pension_capital`}
              label="Pension Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.death.monthly_income`}
              label="Monthly Income"
            />
          </FormControl>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Perm. Disability</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.perm_disability.group_capital`}
              label="Group Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.perm_disability.provident_capital`}
              label="Provident Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.perm_disability.pension_capital`}
              label="Pension Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.perm_disability.monthly_income`}
              label="Monthly Income"
            />
          </FormControl>
        </TableCell>
      </TableRow>

      {/* ======================================= Severe Illness ======================================= */}
      {/* ============================================================================================== */}

      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Severe Illness</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.severe_illness.group_capital`}
              label="Group Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.severe_illness.provident_capital`}
              label="Provident Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.severe_illness.pension_capital`}
              label="Pension Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall" />
      </TableRow>

      {/* ======================================= Retirement ======================================= */}
      {/* ========================================================================================== */}

      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Perm. Disability</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.retirement.group_capital`}
              label="Group Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.retirement.provident_capital`}
              label="Provident Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.retirement.pension_capital`}
              label="Pension Capital"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.retirement.monthly_income`}
              label="Monthly Income"
            />
          </FormControl>
        </TableCell>
      </TableRow>

      {/* ======================================= Temp Disability ======================================= */}
      {/* =============================================================================================== */}
      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Temp. Disability</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
        </TableCell>
        <TableCell className="cellPaddingSmall">
        </TableCell>
        <TableCell className="cellPaddingSmall">
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.approved_fund_provisions.temp_disability.monthly_income`}
              label="Monthly Income"
            />
          </FormControl>
        </TableCell>
      </TableRow>

    </TableBody>
  </Table>
);

export default GroupBenefits;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/RetirementFund/components/ApprovedFunds.jsx